import React from "react";
import "./Home.css";
import SEO from "../../components/common/SEO";
import useFounderBirthday from "../../hooks/useFounderBirthday";
import {
    HeroSection,
    BirthdaySection,
    // RamadanSection, // ← Uncomment during Ramadan
    // EidSection, // ← Uncomment during Eid season
    CreativeSamuraiBanner,
    AcademyRecordedSection,
    ServicesSection,
    PackageSection,
    ProjectsSection,
    ExploreMoreSection,
    StatsSection,
    ClientsSection,
    TeamSection,
    ReviewsSection
} from "./components";

const Home = () => {
    // Switches itself on every 23 September - nothing to uncomment.
    const isFounderBirthday = useFounderBirthday();

    const structuredData = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "@id": "https://arvixcreative.com/#organization",
                "name": "Arvix Creative",
                "alternateName": ["Tanvirus Pixels", "Tanvir Creative Studio"],
                "url": "https://arvixcreative.com",
                "logo": {
                    "@type": "ImageObject",
                    "@id": "https://arvixcreative.com/#logo",
                    "url": "https://arvixcreative.com/logo512.png",
                    "width": 512,
                    "height": 512
                },
                "description": "Professional creative studio specializing in brand identity, UI/UX design, web development, and visual solutions. 120+ projects completed with 85+ happy clients and 5+ years of experience.",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "01No. Goli, Sakib Tower, Keranihat, Satkania",
                    "addressLocality": "Chattogram",
                    "addressRegion": "Chattogram",
                    "postalCode": "4000",
                    "addressCountry": "BD"
                },
                "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "+8801645076455",
                    "contactType": "customer service",
                    "email": "arvixcreative@gmail.com",
                    "areaServed": "BD",
                    "availableLanguage": ["English", "Bengali"]
                },
                "sameAs": [
                    "https://www.facebook.com/arvix.creative",
                    "https://www.instagram.com/arvix.creative"
                ],
                "foundingDate": "2018",
                "numberOfEmployees": {
                    "@type": "QuantitativeValue",
                    "minValue": 5,
                    "maxValue": 10
                },
                "areaServed": {
                    "@type": "Country",
                    "name": "Bangladesh"
                },
                "serviceType": "Creative Services",
                "knowsAbout": [
                    "Brand Identity Design",
                    "UI/UX Design",
                    "Graphic Design",
                    "Logo Design",
                    "Printing and Packaging"
                ]
            },
            {
                "@type": "WebSite",
                "@id": "https://arvixcreative.com/#website",
                "url": "https://arvixcreative.com",
                "name": "Arvix Creative",
                "description": "Professional creative studio specializing in brand identity, UI/UX design, web development, and visual solutions.",
                "publisher": {
                    "@id": "https://arvixcreative.com/#organization"
                },
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                        "@type": "EntryPoint",
                        "urlTemplate": "https://arvixcreative.com/projects?search={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                }
            },
            {
                "@type": "WebPage",
                "@id": "https://arvixcreative.com/#webpage",
                "url": "https://arvixcreative.com",
                "name": "Arvix Creative - Creative Studio | Brand Identity, UI/UX, Web Development",
                "description": "Professional creative studio specializing in brand identity, UI/UX design, web development, and visual solutions. 120+ projects completed with 85+ happy clients and 5+ years of experience.",
                "isPartOf": {
                    "@id": "https://arvixcreative.com/#website"
                },
                "about": {
                    "@id": "https://arvixcreative.com/#organization"
                },
                "primaryImageOfPage": {
                    "@id": "https://arvixcreative.com/#logo"
                }
            },
            {
                "@type": "Service",
                "serviceType": "Brand Identity Design",
                "provider": {
                    "@id": "https://arvixcreative.com/#organization"
                },
                "areaServed": {
                    "@type": "Country",
                    "name": "Bangladesh"
                },
                "description": "Complete brand identity solutions including logo design, color palettes, typography, and comprehensive brand guidelines for businesses of all sizes."
            },
            {
                "@type": "Service",
                "serviceType": "UI/UX Design",
                "provider": {
                    "@id": "https://arvixcreative.com/#organization"
                },
                "areaServed": {
                    "@type": "Country",
                    "name": "Bangladesh"
                },
                "description": "User-centered solutions for web and mobile applications, focusing on intuitive user experiences and modern interfaces."
            },
            {
                "@type": "Service",
                "serviceType": "Printing and Packaging",
                "provider": {
                    "@id": "https://arvixcreative.com/#organization"
                },
                "areaServed": {
                    "@type": "Country",
                    "name": "Bangladesh"
                },
                "description": "Professional printing and packaging services including business cards, brochures, product packaging, and large format printing for maximum visual impact."
            }
        ]
    };

    return (
        <>
            <SEO 
                title="Arvix Creative - Creative Studio | Brand Identity, UI/UX, Web Development"
                description="Professional creative studio specializing in brand identity, UI/UX design, web development, and visual solutions. 120+ projects completed with 85+ happy clients and 5+ years of experience. Based in Chattogram, Bangladesh."
                keywords="arvix, arvix creative, creative studio, brand identity, UI/UX design, web development, logo design, branding, visual design, Bangladesh, Chattogram, professional services, tanvirus, tanvir, pixels, tanvirus pixels"
                structuredData={structuredData}
            />
            <main className="min-h-screen">
                {isFounderBirthday && <BirthdaySection />}
                <HeroSection />
                {/* <RamadanSection /> */} {/* ← Uncomment during Ramadan */}
                {/* <EidSection /> */} {/* ← Uncomment during Eid season */}
                <CreativeSamuraiBanner />
                <AcademyRecordedSection />
                <ServicesSection />
                <ProjectsSection />
                <TeamSection />
                <PackageSection />
                <StatsSection />
                <ClientsSection />
                <ReviewsSection />
                <ExploreMoreSection />
            </main>
        </>
    );
};

export default Home;
